import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { fmtMoney, fmtPrice } from "../components/Format";

export default function Trades() {
  const { mode } = useAuth();
  const [trades, setTrades] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/trades", { params: { limit: 200, mode } });
      setTrades(r.data);
    } catch { /* ignore transient refresh failures */ }
  }, [mode]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 1500);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <div className="space-y-6" data-testid="trades-page">
      <div>
        <div className="label-xs">Execution Stream</div>
        <h1 className="text-3xl font-[Chivo] tracking-tight">Active Trades</h1>
      </div>

      <div className="border border-border bg-[#0F0F0F]">
        <div className="px-4 py-3 border-b border-border flex justify-between text-xs text-neutral-400">
          <div className="label-xs">Latest {trades.length} trades · {mode.toUpperCase()}</div>
          <div className="num text-[#00E676]">{trades.filter(t=>t.pnl>0).length} wins · <span className="text-[#FF3B30]">{trades.filter(t=>t.pnl<=0).length} losses</span></div>
        </div>
        <div className="overflow-auto" style={{ maxHeight: "calc(100vh - 240px)" }}>
          <table className="w-full text-sm" data-testid="trades-table">
            <thead className="sticky top-0 bg-[#0F0F0F]">
              <tr className="border-b border-border">
                <th className="text-left px-3 py-2 label-xs">Time</th>
                <th className="text-left px-3 py-2 label-xs">Symbol</th>
                <th className="text-left px-3 py-2 label-xs">Strategy</th>
                <th className="text-left px-3 py-2 label-xs">Side</th>
                <th className="text-right px-3 py-2 label-xs">Qty</th>
                <th className="text-right px-3 py-2 label-xs">Entry</th>
                <th className="text-right px-3 py-2 label-xs">Exit</th>
                <th className="text-right px-3 py-2 label-xs">Fee</th>
                <th className="text-right px-3 py-2 label-xs">PnL</th>
              </tr>
            </thead>
            <tbody>
              {trades.length === 0 && (
                <tr><td colSpan={9} className="px-3 py-10 text-center text-neutral-500">No trades yet. Start a bot to generate executions.</td></tr>
              )}
              {trades.map((t) => (
                <tr key={t.id} data-testid={`trade-row-${t.id}`} className="border-b border-border hover:bg-[#141414]">
                  <td className="px-3 py-2 num text-neutral-400 text-xs">{new Date(t.closed_at).toLocaleTimeString()}</td>
                  <td className="px-3 py-2 font-[Chivo]">{t.symbol}</td>
                  <td className="px-3 py-2 text-xs text-neutral-400">{t.strategy}</td>
                  <td className={`px-3 py-2 text-xs uppercase ${t.side === "buy" ? "text-[#00E676]" : "text-[#FF3B30]"}`}>{t.side}</td>
                  <td className="px-3 py-2 text-right num">{t.qty.toFixed(6)}</td>
                  <td className="px-3 py-2 text-right num">${fmtPrice(t.entry_price)}</td>
                  <td className="px-3 py-2 text-right num">${fmtPrice(t.exit_price)}</td>
                  <td className="px-3 py-2 text-right num text-neutral-500">${fmtMoney(t.fee, 3)}</td>
                  <td className={`px-3 py-2 text-right num ${t.pnl >= 0 ? "profit" : "loss"}`}>{t.pnl >= 0 ? "+" : ""}${fmtMoney(t.pnl, 3)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
